export const termsOfUsePath = '/terms-of-use';
